import VehicleTaskForm from './VehicleTaskForm';

/** IAD — Vehicle maintenance (settlement) */
export default function Frame53() {
  return <VehicleTaskForm taskKind="maintenance" />;
}
